var _style, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _g, _g2, _rect58, _g3, _g4, _g5, _rect59, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnakinHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0ash{fill:#BCBCBB;}\r\n\t.st1ash{fill:#5C5C5C;}\r\n\t.st2ash{fill:#9C9B9B;}\r\n\t.st3ash{fill:#010202;}\r\n\t.st4ash{fill:#ADADAD;}\r\n\t.st5ash{fill:#8D8D8E;}\r\n\t.st6ash{fill:#7A7A7A;}\r\n\t.st7ash{fill:#A7B847;}\r\n\t.st8ash{fill:#9BA345;}\r\n\t.st9ash{fill:#3F3F3F;}\r\n\t.st10ash{fill:#848484;}\r\n\t.st11ash{fill:#282828;}\r\n\t.st12ash{fill:#9E9E9D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0ash",
    d: "M28.8,200H14.7c-1.3,0-2.3-1-2.3-2.3V197c0-1.3,1-2.3,2.3-2.3h14.1c1.3,0,2.3,1,2.3,2.3v0.7 C31.1,199,30,200,28.8,200z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 214.5722 180.1362)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 214.0499 180.6585)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 213.5413 181.1671)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 213.019 181.6894)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 212.4142 182.2942)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 211.8919 182.8165)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 217.7534 176.955)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 217.2311 177.4773)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 216.7225 177.9858)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 216.2002 178.5081)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 215.5955 179.1129)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 215.0731 179.6353)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 220.9551 173.7533)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 220.4328 174.2756)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 219.9242 174.7842)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 219.4019 175.3065)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 218.7971 175.9113)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 218.2748 176.4336)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 224.2129 170.4955)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 223.6906 171.0178)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 223.182 171.5264)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 222.6597 172.0487)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 222.0549 172.6535)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 221.5326 173.1758)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 226.3275 168.3809)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 225.8051 168.9032)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 225.2004 169.508)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7,
    y: 197.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 224.678 170.0303)",
    className: "st1ash",
    width: 5.2,
    height: 0.3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 131.8,
    className: "st2ash",
    width: 24.7,
    height: 64.7
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 186.3,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 187.8,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 189.2,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 190.6,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 192.3,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7,
    y: 193.7,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 186.3,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 187.8,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 189.2,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 190.6,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 192.3,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2,
    y: 193.7,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 186.5,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 188,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 189.4,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 190.8,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 192.5,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 193.9,
    className: "st1ash",
    width: 3.9,
    height: 0.8
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 131.8,
    className: "st3ash",
    width: 3.3,
    height: 64.6
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 126.2,
    className: "st4ash",
    width: 18.8,
    height: 5.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1,
    y: 90.2,
    className: "st4ash",
    width: 7.5,
    height: 36.1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 90.2,
    className: "st4ash",
    width: 5.8,
    height: 12.3
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 114.4,
    className: "st4ash",
    width: 5.8,
    height: 11.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 102.2,
    className: "st4ash",
    width: 5.6,
    height: 12.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.8,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.1,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.4,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.7,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.8,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.1,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.4,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.7,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.8,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.1,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.4,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.7,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.9,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.2,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.5,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.8,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.8,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.1,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.4,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.7,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.9,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.2,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.5,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.8,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 12.9,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.2,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.5,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.8,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 13,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 14.3,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 15.6,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2ash",
    cx: 16.9,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 102.2,
    className: "st5ash",
    width: 5.6,
    height: 12.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.6,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 28.9,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.2,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.5,
    cy: 103.1,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.7,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.3,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.6,
    cy: 104.6,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.7,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.2,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.5,
    cy: 106,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.7,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.3,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.6,
    cy: 107.5,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.7,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.3,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.6,
    cy: 108.9,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.7,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.3,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.6,
    cy: 110.4,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.8,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29.1,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.4,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.7,
    cy: 111.8,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 27.8,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 29.1,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 30.4,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6ash",
    cx: 31.7,
    cy: 113.3,
    rx: 0.6,
    ry: 0.7
  }))), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 90.2,
    className: "st7",
    width: 8.3,
    height: 36
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.7,
    y: 93.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 119.3541 68.2034)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 93.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 117.994 69.5635)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 93.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 116.634 70.9236)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.6,
    y: 93.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 115.2739 72.2837)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 93.3,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 113.9138 73.6438)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 103.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.7104 208.253)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 102.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.7104 205.2877)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 100.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.7104 202.3225)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 99.2,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.7104 199.3573)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 97.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.7104 196.392)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 105.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 130.0588 81.9555)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4,
    y: 107,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 131.6354 83.5321)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "23.5,108.5 24.6,108.5 24.6,109.8 23.5,109.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "23.5,110.1 24.6,110.1 24.6,111.4 23.5,111.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 105.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 128.7065 83.3078)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.1,
    y: 107,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 130.2831 84.8844)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "22.1,108.5 23.3,108.5 23.3,109.8 22.1,109.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "22.1,110.1 23.3,110.1 23.3,111.4 22.1,111.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 105.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 127.3685 84.6458)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 107,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 128.9451 86.2224)",
    className: "st8ash",
    width: 1.2,
    height: 1.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "20.8,108.5 21.9,108.5 21.9,109.8 20.8,109.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8ash",
    points: "20.8,110.1 21.9,110.1 21.9,111.4 20.8,111.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 117.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.413 236.8383)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 116.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.413 233.8731)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 114.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.413 230.9078)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 113.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.413 227.9426)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 112,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 45.413 224.9773)",
    className: "st8ash",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 122,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 147.9061 97.067)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    y: 122,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 146.546 98.4271)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.8,
    y: 122,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 145.1859 99.7872)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 122,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 143.8258 101.1472)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 122,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 142.4657 102.5073)",
    className: "st8ash",
    width: 5.8,
    height: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0ash",
    d: "M9.6,28.9h2.5c1.1,0,2.1,0.9,2.1,2.1v4.9c0,1.1-0.9,2.1-2.1,2.1H9.6c-1.1,0-2.1-0.9-2.1-2.1v-4.9 C7.5,29.8,8.5,28.9,9.6,28.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 34,
    transform: "matrix(2.119927e-09 -1 1 2.119927e-09 -23.5997 48.1822)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 33.2,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -22.7841 47.3667)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 32.3,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -21.9117 46.4942)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 31.5,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -21.121 45.7035)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 30.7,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -20.3055 44.888)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 29.8,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -19.433 44.0155)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 29,
    transform: "matrix(2.115931e-09 -1 1 2.115931e-09 -18.5928 43.1753)",
    className: "st9ash",
    width: 0.5,
    height: 3.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0ash",
    d: "M32.9,51.2h-0.8c-1.1,0-2.1-0.9-2.1-2.1v-4.9c0-1.1,0.9-2.1,2.1-2.1h0.8c1.1,0,2.1,0.9,2.1,2.1v4.9 C35,50.2,34.1,51.2,32.9,51.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 42.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 75.5589 12.7103)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 43.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 76.3745 13.5259)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 44.4,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 77.2469 14.3983)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 45.2,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 78.0376 15.189)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 46,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 78.8532 16.0046)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 46.9,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 79.7256 16.877)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 47.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 80.5658 17.7172)",
    className: "st9ash",
    width: 0.5,
    height: 2.8
  }))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 29.7,
    className: "st4ash",
    width: 18.9,
    height: 60.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9ash",
    cx: 24.5,
    cy: 37.6,
    rx: 3,
    ry: 4.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10ash",
    cx: 24.5,
    cy: 39.4,
    rx: 1.1,
    ry: 1.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st10ash",
    cx: 24.5,
    cy: 35.2,
    rx: 0.9,
    ry: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11ash",
    d: "M29.4,29c0-1.2,0-2.3,0-3.5c-0.8,0-1.6,0-2.3,0c0-1.5,0-2.9,0-4.4c-3,0-6.1,0-9.1,0c0,2.6,0,5.1,0,7.7 C21.8,28.9,25.6,29,29.4,29z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12ash",
    d: "M17.3,6.8c4.3,0,8.6,0,12.9,0c-0.6,1.6-1.8,4.9-1.5,9.3c0.2,3.1,1,5.5,1.7,7c-3.6,0-7.1,0-10.7,0 C18.9,17.6,18.1,12.2,17.3,6.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4ash",
    d: "M31.8,27.8c-4.6,0.3-7.1-1.1-8.4-2.8c-3.7-4.3-3.3-13.6-3.3-13.6c0,0,0,0.4,0,0.4c-0.1,0-0.7-2.5-1.9-8.4 c-0.2-0.5-0.8-1.7-1.9-2.5c-1.4-1.1-2.9-1-3.3-0.9c0,2.2,0,4.5,0,6.7c-0.5,0-1,0-1.6,0c0,0.7,0,1.4,0,2.2c-3.1,0-6.3,0-9.4,0 c-1.6,1.9-2.2,4.4-1.9,6.4c0.4,2,1.6,3.5,1.6,3.5C1.8,18.9,1.9,19,2,19.1c1.6,0,3.2,0,4.8,0c0,0.8,0,1.7,0,2.5 c2,0.4,4.1,0.7,6.1,1.1c0,3.4,0,6.7,0,10.1c6.3,0,12.6,0,18.9,0C31.7,31.1,31.7,29.5,31.8,27.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnakinHilt);
export default __webpack_public_path__ + "static/media/anakin-hilt.0f6d0ce4.svg";
export { ForwardRef as ReactComponent };